export default "__VITE_ASSET__DHMx2GR3__"